import { render } from "./group-policy-settings.vue?vue&type=template&id=a9b61cf0&scoped=true&ts=true"
import script from "./group-policy-settings.vue?vue&type=script&lang=ts"
export * from "./group-policy-settings.vue?vue&type=script&lang=ts"

import "./group-policy-settings.vue?vue&type=style&index=0&id=a9b61cf0&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9b61cf0"]])

export default __exports__